import { render } from "./feedbackComponents.vue?vue&type=template&id=12eb8260"
import script from "./feedbackComponents.vue?vue&type=script&lang=js"
export * from "./feedbackComponents.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__